import React from "react";
import "./index.scss";
export var CardItemText = function CardItemText(_ref) {
  var title = _ref.title,
      description = _ref.description,
      secondDescription = _ref.secondDescription;
  return /*#__PURE__*/React.createElement(React.Fragment, null, description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tatum\u2013card-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "tatum-card-description-text"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "tatum-card-description-text"
  }, secondDescription)) : /*#__PURE__*/React.createElement("div", {
    className: "tatum-sigle\u2013card-title"
  }, title));
};